import { render, staticRenderFns } from "./AboutDrug.vue?vue&type=template&id=fc25fede"
import script from "./AboutDrug.vue?vue&type=script&lang=js"
export * from "./AboutDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports